// src/config/config.js (or src/config.js based on your structure)
export const baseUrl = 'https://sfbackend.mayilveera.com'; // Or your actual base URL